import {
  BaseFormEngineRuleConfiguration,
  BaseFormEngineRuleConfigurationSchema,
  RawFormEngineRule,
} from "src/types/formEngineRule";
import * as GQL from "src/types/graphql";

export class RuleInfo {
  public readonly name: string;
  public readonly description: string;
  public readonly tag_ids: string[];
  public readonly enable_automatic_offers: boolean = false;
  constructor(rule: RawFormEngineRule) {
    // AUTO_WAITLIST rules don't have tag_ids or enable_remove_tag
    // Parse them separately
    if (rule.rule_type === GQL.form_engine_rule_type_enum.AUTO_WAITLIST) {
      const rawConfig = JSON.parse(rule.rule_config);
      this.name = rawConfig.rule_name ?? "";
      this.description =
        rawConfig.rule_description ??
        "Automatically create waitlists based on form status";
      this.tag_ids = [];
      this.enable_automatic_offers = rawConfig.enable_automatic_offers ?? false;
      return;
    }

    // For tag-based rules, use BaseFormEngineRuleConfigurationSchema
    const config = BaseFormEngineRuleConfigurationSchema.safeParse(
      JSON.parse(rule.rule_config)
    );
    if (!config.success || !config.data) {
      this.name = "Invalid rule configuration";
      this.description = "Invalid rule configuration";
      this.tag_ids = [];
    } else {
      this.name = config.data.rule_name ?? "";
      this.description = RuleInfo.makeDescription(rule, config.data);
      this.tag_ids = config.data.tag_ids ?? [];
    }
  }

  private static readonly makeDescription = (
    rule: RawFormEngineRule,
    config: BaseFormEngineRuleConfiguration
  ) => {
    if (config.rule_description) {
      return config.rule_description;
    } else {
      switch (rule.rule_type) {
        case GQL.form_engine_rule_type_enum.DYNAMIC_SIBLING_TAG: {
          return "Apply tag when there's at least one sibling";
        }
        case GQL.form_engine_rule_type_enum.GEOGRAPHIC_PREFERENCE_TAG:
        case GQL.form_engine_rule_type_enum.QUESTION_TAG: {
          return "Apply tag based on student answer";
        }
        case GQL.form_engine_rule_type_enum.AUTO_WAITLIST: {
          return "Automatically create waitlists based on form status";
        }
        default: {
          return "Apply tag";
        }
      }
    }
  };
}
